<template>
  <div>
    <a-modal title="提现明细" :visible="dialogVisible" width="50%" @cancel="handleCancel" :footer="null">
      <div class="content">
        <a-table :loading="loading" rowKey="id" :columns="columns" :data-source="list" :pagination="false"> </a-table>
      </div>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
      >
        <!-- <a-button @click="dialogVisible = false">取消</a-button>
        <a-button type="primary" @click="dialogVisible = false" style="margin-left: 10px">提 交</a-button> -->
      </div>
    </a-modal>
  </div>
</template>
<script>
import { getDetail } from '@/api/promotion/index'
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      list: [],
      columns: [
        {
          title: '金额',
          dataIndex: 'withdrawableAmount',
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'statusStr',
          align: 'center'
        },
        {
          title: '提现时间',
          dataIndex: 'paymentTime',
          align: 'center'
        }
      ]
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      console.log('=====' + row.id)
      const par = { id: row.id }
      getDetail(par).then((response) => {
        this.list = response.data
        this.loading = false
      })
    },
    handleCancel() {
      this.dialogVisible = false
    }
  }
}
</script>
<style scoped>
.content {
  padding-bottom: 50px;
  text-align: left;
}
</style>
